var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6043 7.76443C20.4198 7.6214 20.1957 7.52941 19.9576 7.49896C19.7195 7.46851 19.477 7.50082 19.2577 7.59221L15.1775 9.27694L12.8067 5.30846C12.6934 5.12318 12.5292 4.9691 12.3309 4.86191C12.1326 4.75471 11.9073 4.69824 11.6778 4.69824C11.4484 4.69824 11.223 4.75471 11.0247 4.86191C10.8264 4.9691 10.6622 5.12318 10.5489 5.30846L8.17817 9.27694L4.09794 7.59221C3.87821 7.50095 3.63537 7.4686 3.39687 7.4988C3.15838 7.529 2.93373 7.62055 2.74834 7.7631C2.56294 7.90565 2.42419 8.09352 2.34776 8.30547C2.27134 8.51741 2.26029 8.74499 2.31587 8.96246L4.36404 17.0717C4.40321 17.2286 4.47629 17.3766 4.57886 17.5066C4.68143 17.6366 4.81135 17.7459 4.96076 17.8279C5.16303 17.9403 5.3943 17.9999 5.63004 18.0001C5.74464 17.9999 5.85864 17.9848 5.96872 17.9552C9.70206 16.9968 13.6455 16.9968 17.3788 17.9552C17.7197 18.0384 18.0822 17.9926 18.3868 17.8279C18.5371 17.747 18.6678 17.638 18.7705 17.5078C18.8732 17.3777 18.9457 17.2291 18.9835 17.0717L21.0398 8.96246C21.0947 8.74493 21.0831 8.51746 21.0061 8.30576C20.9292 8.09405 20.79 7.90655 20.6043 7.76443Z",
    fill: "#F3B72B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.6776,
    cy: 2.68469,
    r: 2.68469,
    fill: "#F3B72B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.6776,
    cy: 12.0809,
    r: 2.01352,
    fill: "#EF4150"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.4096,
    cy: 7.04756,
    r: 1.67793,
    fill: "#F3B72B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.94551,
    cy: 7.04756,
    r: 1.67793,
    fill: "#F3B72B"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.64372,
    cy: 13.0878,
    r: 1.00676,
    fill: "#EF4150"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.7113,
    cy: 13.0878,
    r: 1.00676,
    fill: "#EF4150"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/Crown.874bb204c85f3128b54fbf6669bde3b9.svg";
export { ForwardRef as ReactComponent };